import { useQueryErrorStateContext } from 'modules/queryBuilder/contexts';
import { AnyComparator, DefaultComparator, FieldType } from 'modules/queryBuilder/types';
import { constructWarningPath } from '../utils/constructWarningPath';

const COMPARATOR_TYPE = 'comparatorType';

export const useValidateObjectDataTypeCondition = () => {
  const { addPathWarning, removePathWarning } = useQueryErrorStateContext();
  return (
    { comparatorType, fieldType }: { comparatorType?: AnyComparator; fieldType: FieldType },
    validationPath: (string | number)[],
  ) => {
    const constructedPath = constructWarningPath(validationPath, COMPARATOR_TYPE);
    if (fieldType !== FieldType.OBJECT && fieldType !== FieldType.NESTED) return;

    if (
      comparatorType === DefaultComparator.IS_NOT_SET ||
      comparatorType === DefaultComparator.IS_SET
    ) {
      removePathWarning(constructedPath);
    } else {
      addPathWarning(
        constructedPath,
        `${comparatorType} is not a valid comparator for object fieldType`,
      );
    }
  };
};
